import { SET_REPORT_DATA } from "./action.types";

export default (state, action) => {
    switch (action.type) {
        case SET_REPORT_DATA:
            return action.payload;
        default:
            return state;
    }
};